import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n/useTranslation';
import openingImage from '../assets/img/ssckphu.jpeg';
import './OpeningPage.css';

const OpeningPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStartClick = () => {
    navigate('/start-analysis');
  };

  return (
    <div className="opening-page">
      <div className="opening-image-container">
        <img src={openingImage} alt={t('opening.imageAlt')} className="opening-image" />
        <div className="overlay-box">
          <h1 className="overlay-heading">{t('opening.heading')}</h1>
          <p className="overlay-text">
            {t('opening.text')}
          </p>
          <button className="overlay-button" onClick={handleStartClick}>
            {t('opening.cta')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpeningPage;
